import { handleApiCall } from "./Interactor"

export const createAddOn = (addOnImageFile, addOnName, addOnPrice, addOnUnit, addOnDesc, addOnType, scheduleAddOn, sportType, onSuccessView, onFailedView) => {

  let formData = new FormData();
  formData.append("[add_on_item][image]", addOnImageFile)
  formData.append("[add_on_item][name]", addOnName)
  formData.append("[add_on_item][price]", addOnPrice)
  formData.append("[add_on_item][unit]", addOnUnit)
  formData.append("[add_on_item][note]", addOnDesc)
  formData.append("[add_on_item][add_on_type]", addOnType)
  formData.append("[add_on_item][sport_type]", sportType)

  // if (addOnType === "Jasa") {
    scheduleAddOn.forEach((element, index) => {
      formData.append(`[add_on_item][add_on_item_schedules_attributes][${index}][date_available]`, element.date_available);
      formData.append(`[add_on_item][add_on_item_schedules_attributes][${index}][start_time]`, element.start_time);
      formData.append(`[add_on_item][add_on_item_schedules_attributes][${index}][end_time]`, element.end_time);
    });  
  // }

  handleApiCall(
    "POST",
    process.env.REACT_APP_CREATE_ADDON, formData,
    (responseJSON) => {
      // console.log("result post ", responseJSON)
    },
    onSuccessView,
    onFailedView
  )

}



export const getAddOnList = (onSuccessView, onFailedView) => {

  handleApiCall(
    "GET",
    process.env.REACT_APP_CREATE_ADDON, {},
    (responseJSON) => {
      // console.log("result post ", responseJSON)
    },
    onSuccessView,
    onFailedView
  )

}

export const deleteAddOn = (addOnId, onSuccessView, onFailedView) => {

  handleApiCall(
    "DELETE",
    process.env.REACT_APP_CREATE_ADDON + "/" + addOnId, {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )

}

export const getDetailsAddOn = (addOnId, onSuccessView, onFailedView) => {
  console.log("id nyas ", addOnId)
  handleApiCall(
    "GET",
    process.env.REACT_APP_CREATE_ADDON + "/" + addOnId, {},
    (responseJSON) => {


    },
    onSuccessView,
    onFailedView
  )

}

export const updateAddOn = (addOnId, addOnImage, addOnName, addOnUnit, addOnPrice, addOnDesc, addOnType, scheduleAddOn, sportType, onSuccessView, onFailedView) => {

  const formData = new FormData();
  formData.append("[add_on_item][name]", addOnName)
  formData.append("[add_on_item][price]", addOnPrice)
  formData.append("[add_on_item][unit]", addOnUnit)
  formData.append("[add_on_item][image]", addOnImage)
  formData.append("[add_on_item][note]", addOnDesc)
  formData.append("[add_on_item][add_on_type]", addOnType)
  formData.append("[add_on_item][sport_type]", sportType)
  
  // if (addOnType === "Jasa") {
    scheduleAddOn.forEach((element, index) => {
      if (element.id !== undefined) {
        if (element._destroy === 1) {
          formData.append(`[add_on_item][add_on_item_schedules_attributes][${index}][id]`, element.id);
          formData.append(`[add_on_item][add_on_item_schedules_attributes][${index}][_destroy]`, element._destroy);
        }
      } else {
        formData.append(`[add_on_item][add_on_item_schedules_attributes][${index}][date_available]`, element.date_available);
        formData.append(`[add_on_item][add_on_item_schedules_attributes][${index}][start_time]`, element.start_time);
        formData.append(`[add_on_item][add_on_item_schedules_attributes][${index}][end_time]`, element.end_time);
      }
    });  
  // }

  handleApiCall(
    "PUT",
    process.env.REACT_APP_CREATE_ADDON + "/" + addOnId, formData,
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )

}